import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { useAssetType } from '../../../context-providers/asset-type/AssetTypeContext';

interface Props {
  disabled?: boolean;
}

export const ISINTextField: FC<Props> = ({ disabled }) => {
  const { assetType } = useAssetType();
  const { t } = useTranslation();
  const formik = useFormikContext();

  const label = t(
    assetType === 'builderOwnerModel' || assetType === 'powerplantPortfolio' || 'citizenParticipationLoan'
      ? 'dashboard.assets.addedit.investment.investmentterms.fields.isinOrId.label'
      : 'dashboard.assets.addedit.investment.investmentterms.fields.isin.label',
  );

  return <DefaultFastTextField disabled={disabled} label={label} fieldName="investmentDetails.ISIN" formik={formik} />;
};
